import { Injectable } from '@angular/core';
import { AppMessage, toAppMessage } from '../classes/app-message';

@Injectable()
export class MessageService {
  message: AppMessage | null = null;
  infoMessage: AppMessage | null = null;

  show(message: string | AppMessage) {
    this.message = toAppMessage(message);
  }

  showAndHideAfterDelay(message: string | AppMessage, delay: number) {
    this.show(message);

    this.hide(delay);
  }

  hide(optionalDelay?: number) {
    setTimeout(() => {
      this.hideMessage();
      this.hideInfo();
    }, optionalDelay);
  }

  showInfo(message: string | AppMessage, delay?: number) {
    this.infoMessage = toAppMessage(message);

    if (delay) {
      this.hide(delay);
    }
  }

  hideMessage() {
    this.message = null;
  }

  hideInfo() {
    this.infoMessage = null;
  }
}
